export const tooltipStrings = {
    NUMERO_REMESSA_DINAMICO: "Quando um número de remessa não for informado, significa que o banco reinicia diariamente o número de remessa",
    EXIBIR_TAXA_VENCIMENTO: "Determina nas instruções do boleto a exibição de multa e juros diário em caso de atraso no pagamento",
    REGISTRO_INSTANTANEO: "Define a transmissão automática da remessa no banco durante a emissão do boleto"
};
